import useSWR from 'swr';
import { getGoogleReviews, getMostWanted } from '@/libs/get-data';

export const useGoogleReviews = () => {
	return useSWR('google-reviews', getGoogleReviews, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		dedupingInterval: 1000 * 60 * 10,
	});
};

export const useMostWanted = ({ selectedLang }) => {
	return useSWR(
		() => (selectedLang ? ['most-wanted-products', selectedLang] : null),
		(_, selectedLang) => getMostWanted({ selectedLang }),
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			dedupingInterval: 1000 * 60 * 10,
		}
	);
};
